import { API } from "../../config";

export const getAllSubmittedProof = (token) =>{
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/submit-proof`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        //body: JSON.stringify(data)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}

export const getAllAcceptedProof = (token) =>{
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/accepted-proof`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        //body: JSON.stringify(data)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}

export const getDeclinedProof = (token) =>{
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/declined-proof`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        //body: JSON.stringify(data)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}

export const storeUserBalance = ( id, data, token) => {
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/top-up/user-balance/${id}` , {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}

export const updateProofStatus = ( id, data, token) => {
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/submit-proof/status/${id}` , {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}  


export const updateProofStatusDecl = ( id, token) => {
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/decline-proof/${id}` , {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}  

export const storeTransaction = (userId, data, token) =>{
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/transaction-history/${userId}` , {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      })
      .then(response => {
          return response.json();
      })
      .catch(err => console.log(err));
}